var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRefreshCircle = function SvgRefreshCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M18.835 10.001a8.333 8.333 0 1 1-16.667 0 8.333 8.333 0 0 1 16.667 0M5.052 9.237a5.49 5.49 0 0 1 5.457-4.86c1.782 0 3.366.848 4.369 2.16a.625.625 0 1 1-.993.759 4.24 4.24 0 0 0-3.376-1.67 4.24 4.24 0 0 0-4.197 3.611h.303a.625.625 0 0 1 .442 1.068l-.974.972a.625.625 0 0 1-.883 0l-.974-.972a.625.625 0 0 1 .442-1.068zm10.75-.511a.625.625 0 0 0-.883 0l-.973.972a.625.625 0 0 0 .442 1.067h.302a4.24 4.24 0 0 1-4.197 3.611 4.24 4.24 0 0 1-3.364-1.655.625.625 0 1 0-.99.763 5.49 5.49 0 0 0 4.354 2.142 5.49 5.49 0 0 0 5.458-4.86h.384a.625.625 0 0 0 .441-1.068z",
    clipRule: "evenodd"
  })));
};
export default SvgRefreshCircle;